import { ISwAppMerchantAccountsApi } from "../../interfaces-and-types";

type TMerchantAccountUrls = {
  [key in keyof ISwAppMerchantAccountsApi]: string;
};

const rootMerchantAccountUrl = "/account";

export const merchantAccountUrls: TMerchantAccountUrls = {
  createMerchantAccount: `${rootMerchantAccountUrl}/create`,
  addNewBusiness: `${rootMerchantAccountUrl}/add-new-business`,
  getAllBusinesses: `${rootMerchantAccountUrl}/list-businessess`,
  resendConfirmationEmail: `${rootMerchantAccountUrl}/resend-confirmation-email`,
  getMerchantAccounts: `${rootMerchantAccountUrl}/list`,
};
